// pages/Dashboard.jsx
import SubscriptionSuccessPage from "../../components/home/membershipPlanComponents/SubscriptionSuccessPage";
import HomeLayout from "../../components/home/HomeLayout";

export default function Dashboard() {
  return (
    <HomeLayout>
      <SubscriptionSuccessPage />
    </HomeLayout>
  );
}
